import { ICompany } from "src/app/company/models/company";
import { IEmployee } from "src/app/company/models/employee";
import { IBase } from "src/app/core/models/base";
import { IProduct } from "src/app/products/models/product";

export interface IOrder extends IBase{
    remarks: string,
    orderState: OrderStates,
    internalOrderNumber: string,
    sequentialOrderNumber: number
    orderPositions: IOrderPosition[],
    companyId: string,
    company: ICompany,
    employeeId: string,
    employee: IEmployee
}

export interface IOrderPosition extends IBase {
    quantity: number,
    productId: string,
    product?: IProduct,
    location: string
}

export interface ICreateOrderRequest{
    remarks: string,
    internalOrderNumber: string,
    companyId: string
}

export interface IUpdateOrderRequest{
    id: string,
    orderState: OrderStates,
}

export enum OrderStates {
    open = 10,
    closed = 20
}